import type { PermalinkOptionSelection } from "./permalink";
import type { OptionContract } from "./types";

export function permalinkSelectionForOption(
  contract: OptionContract,
): PermalinkOptionSelection {
  return {
    optionType: contract.type === "call" ? "CALLS" : "PUTS",
    strikePriceCents: Math.round(contract.strike * 100),
  };
}

export function findPermalinkOption(
  contracts: readonly OptionContract[],
  selection: PermalinkOptionSelection,
): OptionContract | null {
  const contractType = selection.optionType === "CALLS" ? "call" : "put";
  return (
    contracts.find(
      (contract) =>
        contract.type === contractType &&
        Math.round(contract.strike * 100) === selection.strikePriceCents,
    ) ?? null
  );
}

export function reconcileSelectedOption(
  selected: OptionContract | null,
  contracts: readonly OptionContract[],
): OptionContract | null {
  if (!selected) return null;
  return contracts.find((contract) => contract.code === selected.code) ?? null;
}
